import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AUTH } from "@/constants/testIds";
import { toast } from "sonner";
import { AuthShell, Field } from "./Login";
import { Mail, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Erreur — réessayez plus tard");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell>
      <Link to="/login" className="inline-flex items-center gap-1 text-xs font-mono uppercase tracking-[0.16em] text-[#5B5B62] hover:text-[#0B2545]">
        <ArrowLeft className="h-3 w-3" /> Retour à la connexion
      </Link>
      <h1 className="mt-4 font-serif font-medium text-3xl md:text-4xl tracking-tight text-[#0B2545] leading-tight">Mot de passe oublié</h1>
      <p className="mt-2 text-sm text-[#5B5B62]">
        Entrez votre adresse courriel — nous vous enverrons un lien pour réinitialiser votre mot de passe.
      </p>
      {done ? (
        <div className="mt-8 border border-emerald-200 bg-emerald-50 rounded-md p-4 text-sm text-emerald-800" data-testid="forgot-success">
          Si cette adresse existe dans notre système, un lien vient d&apos;être envoyé.
          <div className="mt-2 text-xs text-emerald-700">
            (En mode dev, le lien est journalisé dans les logs backend — voir ADMIN_GUIDE.md)
          </div>
          <Link to="/login" className="mt-3 inline-block text-[#0B2545] font-medium hover:underline">
            ← Retour à la connexion
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4" noValidate>
          <Field label="Adresse courriel">
            <input
              data-testid={AUTH.forgotEmail}
              type="email" required autoComplete="email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-md bg-[#F8F7F3] border border-[#E4E1D8] focus:border-[#0B2545] focus:ring-1 focus:ring-[#0B2545] outline-none px-3 py-2.5 text-sm"
            />
          </Field>
          <button
            data-testid={AUTH.forgotSubmit}
            type="submit" disabled={busy}
            className="w-full rounded-md bg-[#0B2545] hover:bg-[#123163] disabled:opacity-60 text-white font-medium py-2.5 transition-colors flex items-center justify-center gap-2"
          >
            <Mail className="h-3.5 w-3.5" strokeWidth={1.8} />
            {busy ? "Envoi…" : "Envoyer le lien"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
